import { render, staticRenderFns } from "./ai_staking.vue?vue&type=template&id=0d78a368&"
import script from "./ai_staking.vue?vue&type=script&lang=js&"
export * from "./ai_staking.vue?vue&type=script&lang=js&"
import style0 from "./ai_staking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports